import { Link } from "react-router-dom";

interface NavItem {
  label: string;
  to: string;
}

interface ProjectNavProps {
  prev: NavItem;
  next: NavItem;
}

export default function ProjectNav({ prev, next }: ProjectNavProps) {
  return (
    <section className="bg-background-100 border-t border-foreground-950/10">
      <div className="px-6 md:px-12 max-w-7xl mx-auto py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 gap-10">
        <Link
          to={prev.to}
          className="group cursor-pointer flex flex-col gap-3 text-left"
        >
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-foreground-700 inline-flex items-center gap-2">
            <i className="ri-arrow-left-line text-base"></i> Previous
          </span>
          <span className="font-display font-black text-3xl md:text-5xl text-foreground-950 leading-tight tracking-tight group-hover:opacity-70 transition-opacity">
            {prev.label}
          </span>
        </Link>
        <Link
          to={next.to}
          className="group cursor-pointer flex flex-col gap-3 md:text-right md:items-end"
        >
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-foreground-700 inline-flex items-center gap-2">
            Next <i className="ri-arrow-right-line text-base"></i>
          </span>
          <span className="font-display font-black text-3xl md:text-5xl text-foreground-950 leading-tight tracking-tight group-hover:opacity-70 transition-opacity">
            {next.label}
          </span>
        </Link>
      </div>
    </section>
  );
}